// One root for every customer-subscriptions query (§8), so invalidating
// ['customer-subscriptions'] reaches the list AND the detail. The detail key used to be
// ['customer-subscription', id], outside that root, so a row Activate/Cancel left an open
// detail page stale.
export const customerSubscriptionsQueryKeys = {
    all: ['customer-subscriptions'] as const,
    list: (filter: Record<string, string>) => ['customer-subscriptions', 'list', filter] as const,
    detail: (id?: string) => ['customer-subscriptions', 'detail', id] as const,
};
